import React, { useEffect } from 'react';
import {useSelector} from 'react-redux';
import { dismissErrorPage } from "utils/crashReporter";
import PaperAirplane from 'assets/zero-state-images/paperAirplaneCrash.svg';
import { Typography } from '@material-ui/core';
import QButton from 'components/QButton';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import { getCurrentTheme } from "themes/themesSelectors";
import styles from './styles';

const useStyles = makeStyles(styles);

const FallbackComponent = () => {
  const classes = useStyles();
  const currentTheme = useSelector(getCurrentTheme);
  useEffect(() => dismissErrorPage(), []);
  return (
    <ThemeProvider theme={currentTheme}>
      <div className={classes.parentContainer}>
        <img alt='paper-airplane' src={PaperAirplane} className={classes.paperAirplane}/>
        <Typography variant='h5' className={classes.textItem}>{`Something isn't right..`}.</Typography>
        <QButton variant='outlined' onClick={() => window.location.reload()} className={classes.tryAgainButton}>
          Try Again
        </QButton>
      </div>
    </ThemeProvider>
  );
};

FallbackComponent.whyDidYouRender = true;

export default FallbackComponent;
